import { success, failure, invalid, request } from "./helpers";
import {
  SEGMENT_LIST,
  SEGMENT_ARCHIVE,
  ARCHIVE_SEGMENT,
  IF_ARCHIVE_SUCCESS,
  GET_ATTRIBUTES,
  SEGMENT_WITH_RULES,
  COPY_SEGMENT,
  CREATE_CAMPAIGN,
  ROLLBACK_VALUE,
  CLEAR_SEGMENT_WITH_RULES,
  SEARCH_BY_NAME,
  SELECTED_SEGMENT,
  RECORD_ACTIVE_QUERY_PARAMS,
  REACTIVATE_SEGMENT,
  CLEAR_REACTIVE_STATUS,
} from "../actions/SegmentList";
import { CLEAR_AUDIENCE_COUNT } from "../actions/SegmentCreation";
import moment from "moment";

const initialState = {
  segment_list_active: {
    data: [],
  },
  segment_list_archive: {
    data: [],
  },
  segment_archive_data: [],
  archive_success: [],
  reactive_success: undefined,
  reactive_on_progress: undefined,
  segment_attributes: "",
  copy_segment: {},
  create_campaign: {
    segment_id: "",
    ifRequestSuccess: false,
    error: false,
    error_payload: "",
  },
  searchByNameResult: [],
  selectedSegmentSetArray: [],
  recordActiveQueryParamsObj: {
    pageNumber: 1,
    sortColumn: "createdTime",
    pageSize: 10,
    status: "Active",
    order: "desc",
  },
};
export const segmentList = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_REACTIVE_STATUS:
      return {
        ...state,
        reactive_on_progress: undefined,
        reactive_success: undefined,
      };
    case success(SEGMENT_LIST):
      action.payload.data.forEach(item => {
        item.createdTime = moment(item.createdTime).format("MM/DD/YYYY");
      });
      action.payload.data.forEach(item => {
        item.archivedTime = moment(item.archivedTime).format("MM/DD/YYYY");
      });
      // mock pageCount
      if (/\/segments\/list\/active/g.test(window.location.href)) {
        return {
          ...state,
          searchByNameResult: undefined,
          segment_list_active: action.payload,
          selectedSegmentSetArray: [],
        };
      }

      if (/\/segments\/list\/archive/g.test(window.location.href)) {
        return {
          ...state,
          searchByNameResult: undefined,
          segment_list_archive: action.payload,
        };
      }
      return {
        ...state,
        searchByNameResult: undefined,
      };
    case success(SEGMENT_ARCHIVE):
      return {
        ...state,
        segment_archive_data: action.payload.data,
      };
    case success(ARCHIVE_SEGMENT):
      return {
        ...state,
      };
    case request(REACTIVATE_SEGMENT):
      return {
        ...state,
        reactive_on_progress: true,
        reactive_success: false,
      };
    case success(REACTIVATE_SEGMENT):
      return {
        ...state,
        reactive_on_progress: false,
        reactive_success: true,
      };
    case IF_ARCHIVE_SUCCESS:
      let arr = [];
      arr.push(action.value);
      return {
        ...state,
        archive_success: arr,
      };
    case success(GET_ATTRIBUTES):
      return {
        ...state,
        segment_attributes: action.payload.attributes,
      };
    case success(COPY_SEGMENT):
      // let rawData = JSON.parse(action.payload.rawData);
      return {
        ...state,
        copy_segment: action.payload,
      };

    case success(SEGMENT_WITH_RULES):
      // let rawData_active = JSON.parse(action.payload.rawData);
      return {
        ...state,
        active_segment_attributes: action.payload,
      };
    case CLEAR_AUDIENCE_COUNT:
    case CLEAR_SEGMENT_WITH_RULES:
      return {
        ...state,
        active_segment_attributes: {},
      };
    case success(CREATE_CAMPAIGN):
      return {
        ...state,
        create_campaign: {
          segment_id: action.payload,
          ifRequestSuccess: true,
          error: false,
        },
      };
    case invalid(CREATE_CAMPAIGN):
      return {
        ...state,
        create_campaign: {
          ifRequestSuccess: false,
          error: true,
          error_payload: action.payload.message,
        },
      };
    case ROLLBACK_VALUE:
      return {
        ...state,
        create_campaign: {
          ...state.create_campaign,
          ifRequestSuccess: action.value,
          error: false,
          error_payload: "",
        },
      };
    case failure(CREATE_CAMPAIGN):
      return {
        ...state,
        create_campaign: {
          error: true,
          error_payload: action.payload.message,
          ifRequestSuccess: false,
        },
      };
    case success(SEARCH_BY_NAME):
      return {
        ...state,
        searchByNameResult: action.payload,
      };
    case SELECTED_SEGMENT:
      if (action.value === "clear") {
        return {
          ...state,
          selectedSegmentSetArray: [],
        };
      } else {
        return {
          ...state,
          selectedSegmentSetArray: action.value,
        };
      }
    case RECORD_ACTIVE_QUERY_PARAMS:
      return {
        ...state,
        recordActiveQueryParamsObj: {
          ...state.recordActiveQueryParamsObj,
          pageNumber: action.value.pageNumber,
          sortColumn: action.value.sortColumn,
          pageSize: action.value.pageSize,
          order: action.value.order,
        },
      };
    default:
      return state;
  }
};

export default {
  segmentList,
};



// WEBPACK FOOTER //
// ./src/reducers/segmentList.js